// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import {
//   Box,
//   Button,
//   VStack,
//   Text,
//   useToast,
//   Flex,
//   Badge,
//   IconButton,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   Input,
//   HStack,
//   Select,
//   InputGroup,
//   InputLeftElement,
// } from '@chakra-ui/react';
// import { ChatIcon, ArrowBackIcon, SearchIcon } from '@chakra-ui/icons';
// import echo from '../utils/echo';

// const AdminChat = () => {
//   const toast = useToast();
//   const [chatHistory, setChatHistory] = useState({});
//   const [activeClient, setActiveClient] = useState(null);
//   const [activeSession, setActiveSession] = useState(null);  // new state
//   const [isChatOpen, setIsChatOpen] = useState(false);
//   const [pendingRequests, setPendingRequests] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [chats, setChats] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortOrder, setSortOrder] = useState('newest'); // 'newest', 'oldest', 'alphabetical'
//   const echoChannel = useRef(null);
//   const adminChannel = useRef(null);
//   const messagesEndRef = useRef(null);
//   const pageID = 19;
  
//   // Function to scroll to bottom of messages
//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   // Establish Echo and Pusher connection
//   useEffect(() => {
//     // Listen to the main chat channel for general messages
//     echoChannel.current = echo.channel('chat');
    
//     // Listen to admin-specific channel for assistance requests
//     adminChannel.current = echo.channel('admin-chat')
//       .listen('chat.message.sent', (e) => {
//         // Handle Laravel backend data structure: e.chat_item
//         const chatItem = e.chat_item;
        
//         if (chatItem && chatItem.message === 'Request Assistance') {
//           // Show a toast notification
//           toast({
//             title: 'Assistance Requested!',
//             description: `Client ${chatItem.sender} needs help.`,
//             status: 'warning',
//             duration: 5000,
//             isClosable: true,
//             position: "top-right",
//           });
          
//           // Add the client to pendingRequests if not already in the list
//           const clientName = chatItem.sender;
//           setPendingRequests((prev) =>
//             prev.includes(clientName) ? prev : [...prev, clientName]
//           );
//         }
        
//         // Update chat history for active sessions
//         if (chatItem && chatItem.session_id === activeSession) {
//           setChatHistory((prev) => {
//             const updatedHistory = { ...prev };
//             if (!updatedHistory[chatItem.session_id]) {
//               updatedHistory[chatItem.session_id] = [];
//             }
//             updatedHistory[chatItem.session_id].push(chatItem);
//             return updatedHistory;
//           });
//           // Scroll to bottom when new message is received
//           setTimeout(() => scrollToBottom(), 100);
//         }
//       })
//       .listen('AssistanceRequested', (e) => {
//         toast({
//           title: 'Assistance Requested!',
//           description: `Client ${e.client_name || e.sender} needs help.`,
//           status: 'warning',
//           duration: 5000,
//           isClosable: true,
//           position: "top-right",
//         });
        
//         // Add the client to pendingRequests
//         const clientName = e.client_name || e.sender;
//         setPendingRequests((prev) =>
//           prev.includes(clientName) ? prev : [...prev, clientName]
//         );
//       });

//     return () => {
//       // Clean up channels
//       try {
//         if (echoChannel.current) {
//           echo.leaveChannel('chat');
//         }
//         if (adminChannel.current) {
//           echo.leaveChannel('admin-chat');
//         }
//       } catch (error) {
//         console.error('Error cleaning up Echo channels:', error);
//       }
//     };
//   }, [toast, activeSession]);

//   // Send a message to the active client via Echo/Pusher
//   const sendMessage = async (messageContent) => {
//     if (activeClient && activeSession) {
//       try {
//         const token = sessionStorage.getItem('accessToken');
        
//         // Send message via API
//         const response = await fetch(`${process.env.REACT_APP_API_URL}/chats/chat/message`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`,
//             'privilege': 'create'
//           },
//           body: JSON.stringify({
//             session_id: activeSession,
//             message: messageContent,
//             sender: 'admin',
//             page_id: pageID
//           }),
//         });

//         const data = await response.json();
        
//         if (data.status === 'success') {
//           // Update local chat history
//           const message = { 
//             sender: 'admin', 
//             content: messageContent, 
//             message: messageContent,
//             created_at: new Date().toISOString()
//           };
          
//           setChatHistory((prev) => {
//             const updatedHistory = { ...prev };
//             if (!updatedHistory[activeSession]) {
//               updatedHistory[activeSession] = [];
//             }
//             updatedHistory[activeSession].push(message);
//             return updatedHistory;
//           });
//           // Scroll to bottom when message is sent
//           setTimeout(() => scrollToBottom(), 100);
//         } else {
//           toast({
//             title: 'Failed to send message',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//             position: "top-right",
//           });
//         }
//       } catch (error) {
//         console.error('Error sending message:', error);
//         toast({
//           title: 'Error sending message',
//           status: 'error',
//           duration: 3000,
//           isClosable: true,
//           position: "top-right",
//         });
//       }
//     }
//   };

//   // Handle sending a message from the input field
//   const handleSendMessage = () => {
//     if (messageText.trim() === '') return;
//     sendMessage(messageText);
//     setMessageText('');
//   };

//   // Back button to return to the pending requests list
//   const handleBack = () => {
//     setActiveClient(null);
//   };

//   // Close the chat modal and reset the active client
//   const closeChatModal = () => {
//     setIsChatOpen(false);
//     setActiveClient(null);
//   };

//   // Add function to fetch chats from the API
//   const fetchChats = useCallback(async () => {
//     try {
//       const token = sessionStorage.getItem('accessToken'); // Adjust as needed
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/chats?page_id=${pageID}`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`,
//           'privilege': 'read_all'
//         },
//       });
//       const data = await response.json();
//       if (data.status === 'success') {
//         setChats(data.data);
//       } else {
//         toast({
//           title: 'Failed to fetch chats',
//           status: 'error',
//           duration: 5000,
//           isClosable: true,
//           position: "top-right",
//         });
//       }
//     } catch (error) {
//       toast({
//         title: 'Error fetching chats',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//         position: "top-right",
//       });
//     }
//   }, [pageID, toast]);

//   // Add function to fetch chat session messages from the API
//   const fetchChatSessionMessages = useCallback(async (sessionId) => {
//     try {
//       const token = sessionStorage.getItem('accessToken'); // Adjust if needed
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/chats/chat?session_id=${sessionId}&page_id=${pageID}`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`,
//           'privilege': 'read_one'
//         },
//       });
//       const data = await response.json();
//       if (data.status === 'success') {
//         setChatHistory(prev => ({ ...prev, [sessionId]: data.data.messages }));
//         // Scroll to bottom when messages are loaded
//         setTimeout(() => scrollToBottom(), 100);
//       } else {
//         toast({
//           title: 'Failed to fetch session messages',
//           status: 'error',
//           duration: 5000,
//           isClosable: true,
// position: "top-right",

//         });
//       }
//     } catch (error) {
//       toast({
//         title: 'Error fetching session messages',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
// position: "top-right",

//       });
//     }
//   }, [pageID, toast]);

//   // New function to select a chat from GET /chats list
//   const selectChat = (sessionId, clientName) => {
//     setActiveClient(clientName);
//     setActiveSession(sessionId);
//     fetchChatSessionMessages(sessionId);
//   };

//   // Listen to specific session channel when activeSession changes
//   useEffect(() => {
//     let sessionChannel = null;
    
//     if (activeSession) {
//       try {
//         // Listen to the specific session channel - matching Laravel backend exactly
//         sessionChannel = echo.channel(`chat.${activeSession}`)
//           .listen('chat.message.sent', (e) => {
//             // Handle Laravel backend data structure: e.chat_item
//             const chatItem = e.chat_item;
            
//             if (chatItem) {
//               // Update chat history for this session
//               setChatHistory((prev) => {
//                 const updatedHistory = { ...prev };
//                 if (!updatedHistory[activeSession]) {
//                   updatedHistory[activeSession] = [];
//                 }
//                 updatedHistory[activeSession].push(chatItem);
//                 return updatedHistory;
//               });
//               // Scroll to bottom when new message is received
//               setTimeout(() => scrollToBottom(), 100);
//             }
//           });
        
//       } catch (error) {
//         console.error('Error setting up session channel:', error);
//       }
//     }

//     return () => {
//       try {
//         if (sessionChannel && activeSession) {
//           echo.leaveChannel(`chat.${activeSession}`);
//           sessionChannel = null;
//         }
//       } catch (error) {
//         console.error('Error cleaning up session channel:', error);
//       }
//     };
//   }, [activeSession]);

//   // Trigger chats fetch whenever the chat modal is opened
//   useEffect(() => {
//     if (isChatOpen) {
//       fetchChats();
//     }
//   }, [isChatOpen, fetchChats]);

//   // Scroll to bottom when chat history changes for active session
//   useEffect(() => {
//     if (activeSession && chatHistory[activeSession]) {
//       setTimeout(() => scrollToBottom(), 100);
//     }
//   }, [chatHistory, activeSession]);

//   // Filter and sort chats based on search term and sort order
//   const filteredAndSortedChats = useMemo(() => {
//     let filtered = chats.filter(chat => 
//       chat.client_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       chat.last_message.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     // Sort based on selected order
//     switch (sortOrder) {
//       case 'newest':
//         return filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//       case 'oldest':
//         return filtered.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
//       case 'alphabetical':
//         return filtered.sort((a, b) => a.client_name.localeCompare(b.client_name));
//       default:
//         return filtered;
//     }
//   }, [chats, searchTerm, sortOrder]);

//   return (
//     <Flex direction="column" h="100vh" p={4}>
//       {/* Floating Chat Button with Notification Badge */}
//       <Box position="fixed" bottom="20px" right="20px" zIndex="999">
//         <Box position="relative">
//           <IconButton
//             icon={<ChatIcon />}
//             bg="rgb( 71, 50, 247)"
//             size="lg"
//             color={"white"}
//             borderRadius="full"
//             onClick={() => setIsChatOpen(true)}
//             boxShadow=""
//             _hover={{
//             bg: "cyan.500",
//             transform: "scale(1.3)",
//             boxShadow: "xl",
//             transition: "all 0.3s ease-in-out",
//             }}
//             transition="all 0.3s ease-in-out"
//           />
//           {pendingRequests.length > 0 && (
//             <Badge
//               position="absolute"
//               top="-1"
//               right="-1"
//               colorScheme="red"
//               borderRadius="full"
//               px={2}
//             >
//               {pendingRequests.length}
//             </Badge>
//           )}
//         </Box>
//       </Box>

//       {/* Chat Modal */}
//       <Modal isOpen={isChatOpen} onClose={closeChatModal} size="4xl">
//         <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
//         <ModalContent maxH="90vh" borderRadius="xl" shadow="2xl">
//           <ModalHeader
//             bg="white"
//             borderTopRadius="xl"
//             borderBottom="1px solid"
//             borderColor="gray.100"
//             py={4}
//           >
//             {activeClient ? (
//               <Flex align="center" justify="space-between">
//                 <Flex align="center">
//                   <IconButton
//                     icon={<ArrowBackIcon />}
//                     variant="ghost"
//                     size="sm"
//                     mr={3}
//                     onClick={handleBack}
//                     _hover={{ bg: "gray.100" }}
//                     borderRadius="lg"
//                   />
//                   <Box>
//                     <Text fontSize="lg" fontWeight="bold" color="gray.800">
//                       {activeClient}
//                     </Text>
//                     <Text fontSize="sm" color="green.500" fontWeight="medium">
//                       Online
//                     </Text>
//                   </Box>
//                 </Flex>
//                 <Badge colorScheme="blue" px={3} py={1} borderRadius="full">
//                   Live Chat
//                 </Badge>
//               </Flex>
//             ) : (
//               <Flex align="center" justify="space-between">
//                 <Text fontSize="xl" fontWeight="bold" color="gray.800">
//                   Customer Support
//                 </Text>
//                 <Badge colorScheme="purple" px={3} py={1} borderRadius="full">
//                   {filteredAndSortedChats.length} Conversations
//                 </Badge>
//               </Flex>
//             )}
//           </ModalHeader>
          
//           <ModalBody p={0} bg="gray.50">
//             {activeClient ? (
//               // Enhanced Chat conversation view
//               <Flex direction="column" h="70vh">
//                 {/* Chat messages container with improved styling */}
//                 <Box
//                   flex={1}
//                   bg="white"
//                   overflowY="auto"
//                   px={6}
//                   py={4}
//                   css={{
//                     '&::-webkit-scrollbar': {
//                       width: '6px',
//                     },
//                     '&::-webkit-scrollbar-track': {
//                       background: '#f1f1f1',
//                       borderRadius: '3px',
//                     },
//                     '&::-webkit-scrollbar-thumb': {
//                       background: '#c1c1c1',
//                       borderRadius: '3px',
//                     },
//                     '&::-webkit-scrollbar-thumb:hover': {
//                       background: '#a8a8a8',
//                     },
//                   }}
//                 >
//                   {chatHistory[activeSession]?.length === 0 ? (
//                     <Flex
//                       direction="column"
//                       align="center"
//                       justify="center"
//                       h="full"
//                       color="gray.500"
//                     >
//                       <Text fontSize="lg" fontWeight="medium" mb={2}>
//                         Start the conversation
//                       </Text>
//                       <Text fontSize="sm">
//                         Send a message to begin chatting with {activeClient}
//                       </Text>
//                     </Flex>
//                   ) : (
//                     <VStack spacing={4} align="stretch">
//                       {chatHistory[activeSession]?.map((msg, index) => (
//                         <Flex
//                           key={index}
//                           justify={msg.sender === 'admin' || msg.sender === 'Admin' ? 'flex-end' : 'flex-start'}
//                           align="flex-end"
//                         >
//                           {msg.sender !== 'admin' && msg.sender !== 'Admin' && (
//                             <Box
//                               w="40px"
//                               h="40px"
//                               borderRadius="full"
//                               bg="blue.500"
//                               display="flex"
//                               alignItems="center"
//                               justifyContent="center"
//                               mr={3}
//                               flexShrink={0}
//                             >
//                               <Text color="white" fontSize="sm" fontWeight="bold">
//                                 {msg.sender?.charAt(0)?.toUpperCase() || 'C'}
//                               </Text>
//                             </Box>
//                           )}
//                           <Box
//                             bg={msg.sender === 'admin' || msg.sender === 'Admin' 
//                               ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//                               : 'white'
//                             }
//                             color={msg.sender === 'admin' || msg.sender === 'Admin' ? 'white' : 'gray.800'}
//                             p={4}
//                             borderRadius="2xl"
//                             maxW="75%"
//                             boxShadow={msg.sender === 'admin' || msg.sender === 'Admin' 
//                               ? 'lg' 
//                               : '0 2px 8px rgba(0,0,0,0.1)'
//                             }
//                             border={msg.sender !== 'admin' && msg.sender !== 'Admin' 
//                               ? '1px solid' 
//                               : 'none'
//                             }
//                             borderColor="gray.200"
//                             position="relative"
//                             _before={msg.sender === 'admin' || msg.sender === 'Admin' ? {
//                               content: '""',
//                               position: 'absolute',
//                               right: '-8px',
//                               bottom: '8px',
//                               width: 0,
//                               height: 0,
//                               borderLeft: '8px solid #667eea',
//                               borderTop: '8px solid transparent',
//                               borderBottom: '8px solid transparent',
//                             } : {
//                               content: '""',
//                               position: 'absolute',
//                               left: '-8px',
//                               bottom: '8px',
//                               width: 0,
//                               height: 0,
//                               borderRight: '8px solid white',
//                               borderTop: '8px solid transparent',
//                               borderBottom: '8px solid transparent',
//                             }}
//                           >
//                             <Text fontSize="md" lineHeight="1.5">
//                               {msg.message || msg.content}
//                             </Text>
//                             <Text
//                               fontSize="xs"
//                               opacity={0.8}
//                               mt={2}
//                               textAlign={msg.sender === 'admin' || msg.sender === 'Admin' ? 'right' : 'left'}
//                             >
//                               {new Date(msg.created_at).toLocaleTimeString([], {
//                                 hour: '2-digit',
//                                 minute: '2-digit'
//                               })}
//                             </Text>
//                           </Box>
//                           {msg.sender === 'admin' || msg.sender === 'Admin' ? (
//                             <Box
//                               w="40px"
//                               h="40px"
//                               borderRadius="full"
//                               bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                               display="flex"
//                               alignItems="center"
//                               justifyContent="center"
//                               ml={3}
//                               flexShrink={0}
//                             >
//                               <Text color="white" fontSize="sm" fontWeight="bold">
//                                 A
//                               </Text>
//                             </Box>
//                           ) : null}
//                         </Flex>
//                       ))}
//                       {/* Element to scroll to */}
//                       <div ref={messagesEndRef} />
//                     </VStack>
//                   )}
//                 </Box>

//                 {/* Enhanced Input area */}
//                 <Box
//                   bg="white"
//                   borderTop="1px solid"
//                   borderColor="gray.200"
//                   p={4}
//                 >
//                   <Flex align="center" gap={3}>
//                     <Input
//                       placeholder="Type your message..."
//                       value={messageText}
//                       onChange={(e) => setMessageText(e.target.value)}
//                       onKeyUp={(e) => {
//                         if (e.key === 'Enter') {
//                           e.preventDefault();
//                           handleSendMessage();
//                         }
//                       }}
//                       bg="gray.50"
//                       border="2px solid"
//                       borderColor="gray.200"
//                       borderRadius="xl"
//                       px={4}
//                       py={3}
//                       fontSize="md"
//                       _focus={{
//                         borderColor: "blue.400",
//                         boxShadow: "0 0 0 1px #3182ce",
//                         bg: "white"
//                       }}
//                       _hover={{
//                         borderColor: "gray.300"
//                       }}
//                     />
//                     <Button
//                       onClick={handleSendMessage}
//                       bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                       color="white"
//                       size="lg"
//                       borderRadius="xl"
//                       px={8}
//                       _hover={{
//                         transform: "translateY(-1px)",
//                         boxShadow: "lg"
//                       }}
//                       _active={{
//                         transform: "translateY(0)"
//                       }}
//                       transition="all 0.2s"
//                       isDisabled={!messageText.trim()}
//                     >
//                       Send
//                     </Button>
//                   </Flex>
//                 </Box>
//               </Flex>



//             ) : (
//               // Enhanced List chats with modern design
//               <Box h="70vh" bg="white">
//                 <VStack spacing={6} p={6} h="full">
//                   {/* Header with improved styling */}
//                   <Box w="full" textAlign="center" pb={2}>
//                     <Text fontSize="2xl" fontWeight="bold" color="gray.800" mb={2}>
//                       Customer Conversations
//                     </Text>
//                     <Text fontSize="md" color="gray.600">
//                       Manage and respond to customer inquiries
//                     </Text>
//                   </Box>
                  
//                   {/* Enhanced Search and Filter Controls */}
//                   <VStack spacing={4} w="full">
//                     {/* Search Input with better styling */}
//                     <InputGroup size="lg">
//                       <InputLeftElement pointerEvents="none" pl={4}>
//                         <SearchIcon color="gray.400" />
//                       </InputLeftElement>
//                       <Input
//                         placeholder="Search conversations by name or message content..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         bg="gray.50"
//                         border="2px solid"
//                         borderColor="gray.200"
//                         borderRadius="xl"
//                         pl={12}
//                         py={3}
//                         fontSize="md"
//                         _focus={{
//                           borderColor: "blue.400",
//                           boxShadow: "0 0 0 1px #3182ce",
//                           bg: "white"
//                         }}
//                         _hover={{
//                           borderColor: "gray.300"
//                         }}
//                       />
//                     </InputGroup>
                    
//                     {/* Sort Filter with better design */}
//                     <HStack w="full" spacing={4} justify="space-between">
//                       <HStack spacing={3}>
//                         <Text fontSize="sm" color="gray.600" fontWeight="medium">
//                           Sort by:
//                         </Text>
//                         <Select
//                           value={sortOrder}
//                           onChange={(e) => setSortOrder(e.target.value)}
//                           size="md"
//                           bg="white"
//                           borderRadius="lg"
//                           borderColor="gray.200"
//                           maxW="200px"
//                           _focus={{
//                             borderColor: "blue.400"
//                           }}
//                         >
//                           <option value="newest">Newest First</option>
//                           <option value="oldest">Oldest First</option>
//                           <option value="alphabetical">Alphabetical</option>
//                         </Select>
//                       </HStack>
                      
//                       {/* Results Count with badge style */}
//                       {searchTerm && (
//                         <Badge colorScheme="blue" px={3} py={1} borderRadius="full" fontSize="sm">
//                           {filteredAndSortedChats.length} result{filteredAndSortedChats.length !== 1 ? 's' : ''}
//                         </Badge>
//                       )}
//                     </HStack>
//                   </VStack>

//                   {/* Enhanced Chats List */}
//                   <Box
//                     flex={1}
//                     w="full"
//                     overflowY="auto"
//                     css={{
//                       '&::-webkit-scrollbar': {
//                         width: '6px',
//                       },
//                       '&::-webkit-scrollbar-track': {
//                         background: '#f1f1f1',
//                         borderRadius: '3px',
//                       },
//                       '&::-webkit-scrollbar-thumb': {
//                         background: '#c1c1c1',
//                         borderRadius: '3px',
//                       },
//                       '&::-webkit-scrollbar-thumb:hover': {
//                         background: '#a8a8a8',
//                       },
//                     }}
//                   >
//                     {filteredAndSortedChats.length > 0 ? (
//                       <VStack spacing={3} align="stretch">
//                         {filteredAndSortedChats.map((chat, index) => (
//                           <Box
//                             key={index}
//                             p={5}
//                             borderRadius="xl"
//                             bg="white"
//                             border="1px solid"
//                             borderColor="gray.200"
//                             _hover={{
//                               borderColor: "blue.300",
//                               transform: "translateY(-2px)",
//                               boxShadow: "lg"
//                             }}
//                             transition="all 0.2s"
//                             cursor="pointer"
//                             onClick={() => selectChat(chat.session_id, chat.client_name)}
//                           >
//                             <Flex align="center" justify="space-between">
//                               <Flex align="center" flex={1}>
//                                 {/* Avatar */}
//                                 <Box
//                                   w="50px"
//                                   h="50px"
//                                   borderRadius="full"
//                                   bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                                   display="flex"
//                                   alignItems="center"
//                                   justifyContent="center"
//                                   mr={4}
//                                   flexShrink={0}
//                                 >
//                                   <Text color="white" fontSize="lg" fontWeight="bold">
//                                     {chat.client_name.charAt(0).toUpperCase()}
//                                   </Text>
//                                 </Box>
                                
//                                 {/* Chat Info */}
//                                 <Box flex={1} minW={0}>
//                                   <Flex align="center" justify="space-between" mb={1}>
//                                     <Text fontWeight="bold" fontSize="lg" color="gray.800">
//                                       {chat.client_name}
//                                     </Text>
//                                     <Text fontSize="xs" color="gray.500">
//                                       {new Date(chat.created_at).toLocaleDateString()} {' '}
//                                       {new Date(chat.created_at).toLocaleTimeString([], {
//                                         hour: '2-digit',
//                                         minute: '2-digit'
//                                       })}
//                                     </Text>
//                                   </Flex>
//                                   <Text
//                                     fontSize="sm"
//                                     color="gray.600"
//                                     noOfLines={2}
//                                     lineHeight="1.4"
//                                   >
//                                     {chat.last_message}
//                                   </Text>
//                                 </Box>
//                               </Flex>
                              
//                               {/* Action Button */}
//                               <Button
//                                 size="md"
//                                 bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                                 color="white"
//                                 borderRadius="lg"
//                                 px={6}
//                                 ml={4}
//                                 _hover={{
//                                   transform: "translateY(-1px)",
//                                   boxShadow: "md"
//                                 }}
//                                 _active={{
//                                   transform: "translateY(0)"
//                                 }}
//                                 transition="all 0.2s"
//                               >
//                                 Open Chat
//                               </Button>
//                             </Flex>
//                           </Box>
//                         ))}
//                       </VStack>
//                     ) : (
//                       <Flex
//                         direction="column"
//                         align="center"
//                         justify="center"
//                         h="full"
//                         color="gray.500"
//                         textAlign="center"
//                       >
//                         <Box
//                           w="80px"
//                           h="80px"
//                           borderRadius="full"
//                           bg="gray.100"
//                           display="flex"
//                           alignItems="center"
//                           justifyContent="center"
//                           mb={4}
//                         >
//                           <ChatIcon boxSize="40px" color="gray.400" />
//                         </Box>
//                         <Text fontSize="xl" fontWeight="bold" mb={2} color="gray.600">
//                           {searchTerm ? 'No conversations found' : 'No conversations yet'}
//                         </Text>
//                         <Text fontSize="md" color="gray.500">
//                           {searchTerm 
//                             ? 'Try adjusting your search terms or filters'
//                             : 'Customer conversations will appear here when they start chatting'
//                           }
//                         </Text>
//                       </Flex>
//                     )}
//                   </Box>
//                 </VStack>
//               </Box>
//             )}
//           </ModalBody>
//           <ModalFooter bg="white" borderBottomRadius="xl" borderTop="1px solid" borderColor="gray.100">
//             <Button
//               onClick={closeChatModal}
//               bg="gray.100"
//               color="gray.700"
//               size="lg"
//               borderRadius="lg"
//               px={8}
//               _hover={{
//                 bg: "gray.200"
//               }}
//             >
//               Close
//             </Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Flex>
//   );
// };

// export default AdminChat;
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import {
  Box,
  Button,
  VStack,
  Text,
  useToast,
  Flex,
  Badge,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  HStack,
  Select,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { ChatIcon, ArrowBackIcon, SearchIcon } from '@chakra-ui/icons';
import echo from '../utils/echo';

const AdminChat = () => {
  const toast = useToast();
  const [chatHistory, setChatHistory] = useState({});
  const [activeClient, setActiveClient] = useState(null);
  const [activeSession, setActiveSession] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [messageText, setMessageText] = useState('');
  const [chats, setChats] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState('newest');
  const echoChannel = useRef(null);
  const adminChannel = useRef(null);
  const messagesEndRef = useRef(null);
  const pageID = 19;

  // Function to scroll to bottom of messages
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Establish Echo connection and listeners
  useEffect(() => {
    // Listen to the main chat channel for general messages
    echoChannel.current = echo.channel('chat');

    // Listen to admin-specific channel for assistance requests
    adminChannel.current = echo.channel('admin-chat');
    adminChannel.current.listen('chat.message.sent', (e) => {
      const chatItem = e.chat_item;

      if (chatItem && chatItem.message === 'Request Assistance') {
        toast({
          title: 'Assistance Requested!',
          description: `Client ${chatItem.sender} needs help.`,
          status: 'warning',
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });

        const clientName = chatItem.sender;
        setPendingRequests((prev) =>
          prev.includes(clientName) ? prev : [...prev, clientName]
        );
      }

      if (chatItem && chatItem.session_id === activeSession) {
        setChatHistory((prev) => {
          const updatedHistory = { ...prev };
          if (!updatedHistory[chatItem.session_id]) {
            updatedHistory[chatItem.session_id] = [];
          }
          updatedHistory[chatItem.session_id].push(chatItem);
          return updatedHistory;
        });
        setTimeout(() => scrollToBottom(), 100);
      }
    });

    adminChannel.current.listen('AssistanceRequested', (e) => {
      toast({
        title: 'Assistance Requested!',
        description: `Client ${e.client_name || e.sender} needs help.`,
        status: 'warning',
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });

      const clientName = e.client_name || e.sender;
      setPendingRequests((prev) =>
        prev.includes(clientName) ? prev : [...prev, clientName]
      );
    });

    return () => {
      try {
        echo.leave('chat');
        echo.leave('admin-chat');
      } catch (error) {
        console.error('Error cleaning up Echo channels:', error);
      }
    };
  }, [toast, activeSession]);

  // Send a message to the active client via API
  const sendMessage = async (messageContent) => {
    if (activeClient && activeSession) {
      try {
        const token = sessionStorage.getItem('accessToken');
        const response = await fetch(`${process.env.REACT_APP_API_URL}/chats/chat/message`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'privilege': 'create'
          },
          body: JSON.stringify({
            session_id: activeSession,
            message: messageContent,
            sender: 'admin',
            page_id: pageID
          }),
        });

        const data = await response.json();

        if (data.status === 'success') {
          const message = {
            sender: 'admin',
            content: messageContent,
            message: messageContent,
            created_at: new Date().toISOString()
          };

          setChatHistory((prev) => {
            const updatedHistory = { ...prev };
            if (!updatedHistory[activeSession]) {
              updatedHistory[activeSession] = [];
            }
            updatedHistory[activeSession].push(message);
            return updatedHistory;
          });
          setTimeout(() => scrollToBottom(), 100);
        } else {
          toast({
            title: 'Failed to send message',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: "top-right",
          });
        }
      } catch (error) {
        console.error('Error sending message:', error);
        toast({
          title: 'Error sending message',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      }
    }
  };

  const handleSendMessage = () => {
    if (messageText.trim() === '') return;
    sendMessage(messageText);
    setMessageText('');
  };

  const handleBack = () => {
    setActiveClient(null);
  };

  const closeChatModal = () => {
    setIsChatOpen(false);
    setActiveClient(null);
  };

  // Fetch chats from the API
  const fetchChats = useCallback(async () => {
    try {
      const token = sessionStorage.getItem('accessToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chats?page_id=${pageID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'privilege': 'read_all'
        },
      });
      const data = await response.json();
      if (data.status === 'success') {
        setChats(data.data);
      } else {
        toast({
          title: 'Failed to fetch chats',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
      }
    } catch (error) {
      toast({
        title: 'Error fetching chats',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    }
  }, [pageID, toast]);

  // Fetch chat session messages from the API
  const fetchChatSessionMessages = useCallback(async (sessionId) => {
    try {
      const token = sessionStorage.getItem('accessToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chats/chat?session_id=${sessionId}&page_id=${pageID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'privilege': 'read_one'
        },
      });
      const data = await response.json();
      if (data.status === 'success') {
        setChatHistory(prev => ({ ...prev, [sessionId]: data.data.messages }));
        setTimeout(() => scrollToBottom(), 100);
      } else {
        toast({
          title: 'Failed to fetch session messages',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
      }
    } catch (error) {
      toast({
        title: 'Error fetching session messages',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    }
  }, [pageID, toast]);

  // Select a chat from GET /chats list
  const selectChat = (sessionId, clientName) => {
    setActiveClient(clientName);
    setActiveSession(sessionId);
    fetchChatSessionMessages(sessionId);
  };

  // Listen to specific session channel when activeSession changes
  useEffect(() => {
    let sessionChannel = null;

    if (activeSession) {
      try {
        sessionChannel = echo.channel(`chat.session.${activeSession}`);
        sessionChannel.listen('chat.message.sent', (e) => {
          const chatItem = e.chat_item;
          if (chatItem && chatItem.session_id === activeSession) {
            setChatHistory((prev) => {
              const updatedHistory = { ...prev };
              if (!updatedHistory[chatItem.session_id]) {
                updatedHistory[chatItem.session_id] = [];
              }
              updatedHistory[chatItem.session_id].push(chatItem);
              return updatedHistory;
            });
            setTimeout(() => scrollToBottom(), 100);
          }
        });
      } catch (error) {
        console.error('Error subscribing to session channel:', error);
      }
    }

    return () => {
      if (activeSession) {
        try {
          echo.leave(`chat.session.${activeSession}`);
        } catch (error) {
          console.error('Error leaving session channel:', error);
        }
      }
    };
  }, [activeSession]);

  // Trigger chats fetch whenever the chat modal is opened
  useEffect(() => {
    if (isChatOpen) {
      fetchChats();
    }
  }, [isChatOpen, fetchChats]);

  // Scroll to bottom when chat history changes for active session
  useEffect(() => {
    scrollToBottom();
  }, [chatHistory, activeSession]);

  // Filter and sort chats based on search term and sort order
  const filteredAndSortedChats = useMemo(() => {
    let filtered = chats;
    if (searchTerm) {
      filtered = filtered.filter(chat =>
        chat.client_name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (sortOrder === 'newest') {
      filtered = filtered.sort((a, b) => new Date(b.last_message_at) - new Date(a.last_message_at));
    } else if (sortOrder === 'oldest') {
      filtered = filtered.sort((a, b) => new Date(a.last_message_at) - new Date(b.last_message_at));
    } else if (sortOrder === 'alphabetical') {
      filtered = filtered.sort((a, b) => (a.client_name || '').localeCompare(b.client_name || ''));
    }
    return filtered;
  }, [chats, searchTerm, sortOrder]);


  return (
    <Flex direction="column" h="100vh" p={4}>
      {/* Floating Chat Button with Notification Badge */}
      <Box position="fixed" bottom="20px" right="20px" zIndex="999">
        <Box position="relative">
          <IconButton
            icon={<ChatIcon />}
            bg="rgb( 71, 50, 247)"
            size="lg"
            color={"white"}
            borderRadius="full"
            onClick={() => setIsChatOpen(true)}
            boxShadow=""
            _hover={{
            bg: "cyan.500",
            transform: "scale(1.3)",
            boxShadow: "xl",
            transition: "all 0.3s ease-in-out",
            }}
            transition="all 0.3s ease-in-out"
          />
          {pendingRequests.length > 0 && (
            <Badge
              position="absolute"
              top="-1"
              right="-1"
              colorScheme="red"
              borderRadius="full"
              px={2}
            >
              {pendingRequests.length}
            </Badge>
          )}
        </Box>
      </Box>

      {/* Chat Modal */}
      <Modal isOpen={isChatOpen} onClose={closeChatModal} size="4xl">
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent maxH="90vh" borderRadius="xl" shadow="2xl">
          <ModalHeader
            bg="white"
            borderTopRadius="xl"
            borderBottom="1px solid"
            borderColor="gray.100"
            py={4}
          >
            {activeClient ? (
              <Flex align="center" justify="space-between">
                <Flex align="center">
                  <IconButton
                    icon={<ArrowBackIcon />}
                    variant="ghost"
                    size="sm"
                    mr={3}
                    onClick={handleBack}
                    _hover={{ bg: "gray.100" }}
                    borderRadius="lg"
                  />
                  <Box>
                    <Text fontSize="lg" fontWeight="bold" color="gray.800">
                      {activeClient}
                    </Text>
                    <Text fontSize="sm" color="green.500" fontWeight="medium">
                      Online
                    </Text>
                  </Box>
                </Flex>
                <Badge colorScheme="blue" px={3} py={1} borderRadius="full">
                  Live Chat
                </Badge>
              </Flex>
            ) : (
              <Flex align="center" justify="space-between">
                <Text fontSize="xl" fontWeight="bold" color="gray.800">
                  Customer Support
                </Text>
                <Badge colorScheme="purple" px={3} py={1} borderRadius="full">
                  {filteredAndSortedChats.length} Conversations
                </Badge>
              </Flex>
            )}
          </ModalHeader>
          
          <ModalBody p={0} bg="gray.50">
            {activeClient ? (
              // Enhanced Chat conversation view
              <Flex direction="column" h="70vh">
                {/* Chat messages container with improved styling */}
                <Box
                  flex={1}
                  bg="white"
                  overflowY="auto"
                  px={6}
                  py={4}
                  css={{
                    '&::-webkit-scrollbar': {
                      width: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f1f1',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#c1c1c1',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#a8a8a8',
                    },
                  }}
                >
                  {chatHistory[activeSession]?.length === 0 ? (
                    <Flex
                      direction="column"
                      align="center"
                      justify="center"
                      h="full"
                      color="gray.500"
                    >
                      <Text fontSize="lg" fontWeight="medium" mb={2}>
                        Start the conversation
                      </Text>
                      <Text fontSize="sm">
                        Send a message to begin chatting with {activeClient}
                      </Text>
                    </Flex>
                  ) : (
                    <VStack spacing={4} align="stretch">
                      {chatHistory[activeSession]?.map((msg, index) => (
                        <Flex
                          key={index}
                          justify={msg.sender === 'admin' || msg.sender === 'Admin' ? 'flex-end' : 'flex-start'}
                          align="flex-end"
                        >
                          {msg.sender !== 'admin' && msg.sender !== 'Admin' && (
                            <Box
                              w="40px"
                              h="40px"
                              borderRadius="full"
                              bg="blue.500"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              mr={3}
                              flexShrink={0}
                            >
                              <Text color="white" fontSize="sm" fontWeight="bold">
                                {msg.sender?.charAt(0)?.toUpperCase() || 'C'}
                              </Text>
                            </Box>
                          )}
                          <Box
                            bg={msg.sender === 'admin' || msg.sender === 'Admin' 
                              ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                              : 'white'
                            }
                            color={msg.sender === 'admin' || msg.sender === 'Admin' ? 'white' : 'gray.800'}
                            p={4}
                            borderRadius="2xl"
                            maxW="75%"
                            boxShadow={msg.sender === 'admin' || msg.sender === 'Admin' 
                              ? 'lg' 
                              : '0 2px 8px rgba(0,0,0,0.1)'
                            }
                            border={msg.sender !== 'admin' && msg.sender !== 'Admin' 
                              ? '1px solid' 
                              : 'none'
                            }
                            borderColor="gray.200"
                            position="relative"
                            _before={msg.sender === 'admin' || msg.sender === 'Admin' ? {
                              content: '""',
                              position: 'absolute',
                              right: '-8px',
                              bottom: '8px',
                              width: 0,
                              height: 0,
                              borderLeft: '8px solid #667eea',
                              borderTop: '8px solid transparent',
                              borderBottom: '8px solid transparent',
                            } : {
                              content: '""',
                              position: 'absolute',
                              left: '-8px',
                              bottom: '8px',
                              width: 0,
                              height: 0,
                              borderRight: '8px solid white',
                              borderTop: '8px solid transparent',
                              borderBottom: '8px solid transparent',
                            }}
                          >
                            <Text fontSize="md" lineHeight="1.5">
                              {msg.message || msg.content}
                            </Text>
                            <Text
                              fontSize="xs"
                              opacity={0.8}
                              mt={2}
                              textAlign={msg.sender === 'admin' || msg.sender === 'Admin' ? 'right' : 'left'}
                            >
                              {new Date(msg.created_at).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </Text>
                          </Box>
                          {msg.sender === 'admin' || msg.sender === 'Admin' ? (
                            <Box
                              w="40px"
                              h="40px"
                              borderRadius="full"
                              bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              ml={3}
                              flexShrink={0}
                            >
                              <Text color="white" fontSize="sm" fontWeight="bold">
                                A
                              </Text>
                            </Box>
                          ) : null}
                        </Flex>
                      ))}
                      {/* Element to scroll to */}
                      <div ref={messagesEndRef} />
                    </VStack>
                  )}
                </Box>

                {/* Enhanced Input area */}
                <Box
                  bg="white"
                  borderTop="1px solid"
                  borderColor="gray.200"
                  p={4}
                >
                  <Flex align="center" gap={3}>
                    <Input
                      placeholder="Type your message..."
                      value={messageText}
                      onChange={(e) => setMessageText(e.target.value)}
                      onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleSendMessage();
                        }
                      }}
                      bg="gray.50"
                      border="2px solid"
                      borderColor="gray.200"
                      borderRadius="xl"
                      px={4}
                      py={3}
                      fontSize="md"
                      _focus={{
                        borderColor: "blue.400",
                        boxShadow: "0 0 0 1px #3182ce",
                        bg: "white"
                      }}
                      _hover={{
                        borderColor: "gray.300"
                      }}
                    />
                    <Button
                      onClick={handleSendMessage}
                      bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                      color="white"
                      size="lg"
                      borderRadius="xl"
                      px={8}
                      _hover={{
                        transform: "translateY(-1px)",
                        boxShadow: "lg"
                      }}
                      _active={{
                        transform: "translateY(0)"
                      }}
                      transition="all 0.2s"
                      isDisabled={!messageText.trim()}
                    >
                      Send
                    </Button>
                  </Flex>
                </Box>
              </Flex>



            ) : (
              // Enhanced List chats with modern design
              <Box h="70vh" bg="white">
                <VStack spacing={6} p={6} h="full">
                  {/* Header with improved styling */}
                  <Box w="full" textAlign="center" pb={2}>
                    <Text fontSize="2xl" fontWeight="bold" color="gray.800" mb={2}>
                      Customer Conversations
                    </Text>
                    <Text fontSize="md" color="gray.600">
                      Manage and respond to customer inquiries
                    </Text>
                  </Box>
                  
                  {/* Enhanced Search and Filter Controls */}
                  <VStack spacing={4} w="full">
                    {/* Search Input with better styling */}
                    <InputGroup size="lg">
                      <InputLeftElement pointerEvents="none" pl={4}>
                        <SearchIcon color="gray.400" />
                      </InputLeftElement>
                      <Input
                        placeholder="Search conversations by name or message content..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="xl"
                        pl={12}
                        py={3}
                        fontSize="md"
                        _focus={{
                          borderColor: "blue.400",
                          boxShadow: "0 0 0 1px #3182ce",
                          bg: "white"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                    </InputGroup>
                    
                    {/* Sort Filter with better design */}
                    <HStack w="full" spacing={4} justify="space-between">
                      <HStack spacing={3}>
                        <Text fontSize="sm" color="gray.600" fontWeight="medium">
                          Sort by:
                        </Text>
                        <Select
                          value={sortOrder}
                          onChange={(e) => setSortOrder(e.target.value)}
                          size="md"
                          bg="white"
                          borderRadius="lg"
                          borderColor="gray.200"
                          maxW="200px"
                          _focus={{
                            borderColor: "blue.400"
                          }}
                        >
                          <option value="newest">Newest First</option>
                          <option value="oldest">Oldest First</option>
                          <option value="alphabetical">Alphabetical</option>
                        </Select>
                      </HStack>
                      
                      {/* Results Count with badge style */}
                      {searchTerm && (
                        <Badge colorScheme="blue" px={3} py={1} borderRadius="full" fontSize="sm">
                          {filteredAndSortedChats.length} result{filteredAndSortedChats.length !== 1 ? 's' : ''}
                        </Badge>
                      )}
                    </HStack>
                  </VStack>

                  {/* Enhanced Chats List */}
                  <Box
                    flex={1}
                    w="full"
                    overflowY="auto"
                    css={{
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '3px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        background: '#c1c1c1',
                        borderRadius: '3px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        background: '#a8a8a8',
                      },
                    }}
                  >
                    {filteredAndSortedChats.length > 0 ? (
                      <VStack spacing={3} align="stretch">
                        {filteredAndSortedChats.map((chat, index) => (
                          <Box
                            key={index}
                            p={5}
                            borderRadius="xl"
                            bg="white"
                            border="1px solid"
                            borderColor="gray.200"
                            _hover={{
                              borderColor: "blue.300",
                              transform: "translateY(-2px)",
                              boxShadow: "lg"
                            }}
                            transition="all 0.2s"
                            cursor="pointer"
                            onClick={() => selectChat(chat.session_id, chat.client_name)}
                          >
                            <Flex align="center" justify="space-between">
                              <Flex align="center" flex={1}>
                                {/* Avatar */}
                                <Box
                                  w="50px"
                                  h="50px"
                                  borderRadius="full"
                                  bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  mr={4}
                                  flexShrink={0}
                                >
                                  <Text color="white" fontSize="lg" fontWeight="bold">
                                    {chat.client_name.charAt(0).toUpperCase()}
                                  </Text>
                                </Box>
                                
                                {/* Chat Info */}
                                <Box flex={1} minW={0}>
                                  <Flex align="center" justify="space-between" mb={1}>
                                    <Text fontWeight="bold" fontSize="lg" color="gray.800">
                                      {chat.client_name}
                                    </Text>
                                    <Text fontSize="xs" color="gray.500">
                                      {new Date(chat.created_at).toLocaleDateString()} {' '}
                                      {new Date(chat.created_at).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </Text>
                                  </Flex>
                                  <Text
                                    fontSize="sm"
                                    color="gray.600"
                                    noOfLines={2}
                                    lineHeight="1.4"
                                  >
                                    {chat.last_message}
                                  </Text>
                                </Box>
                              </Flex>
                              
                              {/* Action Button */}
                              <Button
                                size="md"
                                bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                color="white"
                                borderRadius="lg"
                                px={6}
                                ml={4}
                                _hover={{
                                  transform: "translateY(-1px)",
                                  boxShadow: "md"
                                }}
                                _active={{
                                  transform: "translateY(0)"
                                }}
                                transition="all 0.2s"
                              >
                                Open Chat
                              </Button>
                            </Flex>
                          </Box>
                        ))}
                      </VStack>
                    ) : (
                      <Flex
                        direction="column"
                        align="center"
                        justify="center"
                        h="full"
                        color="gray.500"
                        textAlign="center"
                      >
                        <Box
                          w="80px"
                          h="80px"
                          borderRadius="full"
                          bg="gray.100"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          mb={4}
                        >
                          <ChatIcon boxSize="40px" color="gray.400" />
                        </Box>
                        <Text fontSize="xl" fontWeight="bold" mb={2} color="gray.600">
                          {searchTerm ? 'No conversations found' : 'No conversations yet'}
                        </Text>
                        <Text fontSize="md" color="gray.500">
                          {searchTerm 
                            ? 'Try adjusting your search terms or filters'
                            : 'Customer conversations will appear here when they start chatting'
                          }
                        </Text>
                      </Flex>
                    )}
                  </Box>
                </VStack>
              </Box>
            )}
          </ModalBody>
          <ModalFooter bg="white" borderBottomRadius="xl" borderTop="1px solid" borderColor="gray.100">
            <Button
              onClick={closeChatModal}
              bg="gray.100"
              color="gray.700"
              size="lg"
              borderRadius="lg"
              px={8}
              _hover={{
                bg: "gray.200"
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default AdminChat;
